import React, { useRef } from "react"
import { Button } from "@carrotfertility/carotene-core"
import Settings from "#/utils/CarrotConfig"
import { MemberActions } from "#/services/memberActionTracking/memberActions"

interface DynamicCtaButtonProps {
  actionPath: string
  text: string
  trackClick: (action: MemberActions) => void
}

export function DynamicCtaButton({ actionPath, text, trackClick }: DynamicCtaButtonProps): JSX.Element {
  const formRef = useRef<HTMLFormElement>(null)

  const handleClick = () => {
    trackClick(MemberActions.CARROT_COLLECTIVE_CLICKED_CLAIM_DISCOUNT)
    formRef.current?.submit()
  }

  const fullUrl = new URL(actionPath, Settings.CARROT_BACKEND_URL).toString()

  return (
    <>
      <form ref={formRef} action={fullUrl} method="POST" target="_blank" style={{ display: "none" }} />
      <Button color="secondary" size="medium" variant="outlined" onClick={handleClick}>
        {text}
      </Button>
    </>
  )
}
